module.exports = __webpack_public_path__ + "static/media/iosDownload.2928664f.svg";